import PropTypes from "prop-types";

import ProductDetails from "../productDetails";
import ProductImagePreview from "../productImagePreview";

function ProductPreview({ productData }) {
  return (
    <div>
      <div className="flex w-full flex-col space-y-[2.5rem] lg:flex-row lg:space-y-0">
        <div className="w-full lg:w-[50%] ">
          <ProductImagePreview
            productName={productData?.name}
            previewImages={productData?.pictures?.map((el) => el.path)}
          />
        </div>
        <div className="w-full lg:ml-[30px] lg:w-[50%]">
          <ProductDetails product={productData} />
        </div>
      </div>
    </div>
  );
}

ProductPreview.propTypes = {
  productData: PropTypes.object,
};

export default ProductPreview;
